"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.heroBannerHomeComponent = exports.HeroBannerHomeComponent = void 0;
const app_1 = require("app");
const PreviewBox_1 = require("Views/Shared/Components/PreviewBox/PreviewBox");
const KeepTheRhythm_1 = require("../KeepTheRhythm");
class HeroBannerHomeComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.hero-banner-home';
    }
    BeforeInit() {
        this.FixStyles();
    }
    OnInit() {
        const playVideoButton = this.el[0].querySelector('.play-video-button');
        const playVideoWrapper = this.el[0].querySelector('.play-video-wrapper');
        if (!playVideoButton && !playVideoWrapper) {
            return;
        }
        playVideoButton.addEventListener('click', event => {
            (0, PreviewBox_1.showPreviewBoxWithDataFromImage)(event, playVideoButton);
        });
        playVideoButton.addEventListener('keypress', (event) => {
            if (event.key === app_1.keyNameMapping.enter || event.key === app_1.keyNameMapping.space) {
                (0, PreviewBox_1.showPreviewBoxWithDataFromImage)(event, playVideoButton);
            }
        });
        playVideoWrapper.addEventListener('click', event => {
            (0, PreviewBox_1.showPreviewBoxWithDataFromImage)(event, playVideoButton);
        });
        this.FixStyles();
    }
    FixStyles() {
        if (!this.el[0].classList.contains('hero-banner-home--gray')) {
            return;
        }
        const sibling = $(this.el[0])
            .next('.umb-grid')
            .find('.grid-section > div:first-child .column > div > *:first-child')
            .first();
        const siblingBg = sibling.css('background-color');
        if (siblingBg === 'rgba(0, 0, 0, 0)' || siblingBg === 'transparent' || siblingBg === '#fff') {
            this.el[0].style.marginBottom = `${KeepTheRhythm_1.KeepTheRhythmComponent.baseline * 2}px`;
            this.el[0].style.paddingBottom = `${KeepTheRhythm_1.KeepTheRhythmComponent.baseline * 2}px`;
        }
    }
}
exports.HeroBannerHomeComponent = HeroBannerHomeComponent;
exports.heroBannerHomeComponent = new HeroBannerHomeComponent();
